import { VehicleEvents } from 'interfaces/IClaimsSearching'
import request from 'tools/request'

export const getCarrierSafetyEventsTypes = async (carrierId: number) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers/${carrierId}/safety-events/types`,
  )
  return res?.data
}

export const getCarrierVehicles = async (carrierId: number) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers/${carrierId}/vehicles`,
  )
  return res?.data
}

export const getRoutesList = async (payLoad: any) => {
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL}routes`,
    payLoad,
  )
  return res?.data
}

export const getVehiclesSafetyEventsList = async (carrierId: number, payload: any) : Promise<VehicleEvents> => {
  const res = await request.post<VehicleEvents>(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers/${carrierId}/safety-events`,
    payload
  )
  return res?.data
}

export const getSafetyEventDetail = async (
  carrierId: number,
  safetyId: any,
  options?: { useKilometers?: boolean }
) => {
  const url = `${process.env.REACT_APP_CARRIER_API_URL}carriers/${carrierId}/safety-events/${safetyId}`
  const config = options?.useKilometers
    ? { params: { useKilometers: true } }
    : undefined
  const res = await request.get(url, config)
  return res?.data
}

export const getCompanySafetyEventsTypes = async () => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers/claims-searching/types`,
  )
  return res?.data

}

export const getCompanyVehicles = async (carrierId?: number) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers/claims-searching/vehicles${carrierId ? `?carrierId=${carrierId}` : ''}`,
  )
  return res?.data
}

export const getCompanySafetyEvents = async (payload: any) => {
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers/claims-searching/safety-events`,
    payload
  )
  return res?.data
}